import React, { Component } from 'react';

class VisSensor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: null,
        };
        this.checkVisibility = this.checkVisibility.bind(this);
    }

    componentDidMount() {
        this.watchID = setInterval(
            () => this.checkVisibility(),
            150
        );
    }

    componentWillUnmount() {
        clearInterval(this.watchID);
    }

    checkVisibility() {
        var isVisible = null;
        var positionFromTop = document.getElementById(this.props.watchDiv).getBoundingClientRect().top;
        if (positionFromTop > 0 && positionFromTop < window.innerHeight) {
            this.setState({ isVisible: true });
            isVisible = true;
        } else {
            this.setState({ isVisible: false });
            isVisible = false;
        }
        if (this.props.onChange) this.props.onChange(isVisible);
    }

    render() {
        if (this.props.children instanceof Function) {
            return this.props.children({
                isVisible: this.state.isVisible,
            });
        }
        return React.Children.only(this.props.children);
    }
}

export default VisSensor;
